import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { ONBOARDING_STEP_TOTAL } from './onboardingSteps';
import './onboardingProgress.css';

export interface OnboardingProgressProps {
  /** 1-based position of the screen being shown. */
  current: number;
  total?: number;
}

/** Segmented step indicator shared by every onboarding wizard screen. */
export function OnboardingProgress({
  current,
  total = ONBOARDING_STEP_TOTAL,
}: OnboardingProgressProps) {
  const { t } = useTranslation();

  return (
    <div
      className="onboarding-progress"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-label={t('common.accessibility.stepProgress', { current, total })}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          className={`onboarding-progress__step${index < current ? ' onboarding-progress__step--done' : ''}`}
        />
      ))}
    </div>
  );
}
